<template>
  <BaseChannelPieChart
    :title="title"
    :item-id="itemId"
    v-bind="$attrs"
  />
</template>

<script>
import BaseChannelPieChart from '@/components/cards/BaseChannelPieChart';

export default {
  name: 'ChannelPieChart',
  components: {
    BaseChannelPieChart,
  },
  props: {
    title: {
      type: String,
      required: true,
    },
    itemId: {
      type: [String, Number],
      required: true,
    },
  },
};
</script>
